import React from 'react'
import './testimonials.css'
import client1 from '../../assets/client1.jpg'
import client2 from '../../assets/client2.jpg'
import client3 from '../../assets/client3.jpg'
import client4 from '../../assets/client4.jpg'

import {  Pagination } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';

import 'swiper/css/pagination';


const data=[
  {
    avatar:client1,
    name:'Harshit raj',
    review:"As per my opinion He is very good developer because when I am working on Project with Aman i learn soo many things and also we make project with full of our efferts ",
  },
  {
    avatar:client2,
    name:'Aman Raj',
    review:"As per my opinion He is very good developer because when I am working on Project with Aman i learn soo many things and also we make project with full of our efferts ",
  },
  {
    avatar:client3,
    name:'Abhay kumar',
    review:"As per my opinion He is very good developer because when I am working on Project with Aman i learn soo many things and also we make project with full of our efferts ",
  },
  {
    avatar:client4,
    name:'Ashutosh Kumar jha',
    review:"As per my opinion He is very good developer because when I am working on Project with Aman i learn soo many things and also we make project with full of our efferts ",
  },
]

const Testimonials=()=> {
  return (
    <section id='testimonials'>
      <h5>Review From Client</h5>
      <h2>Testimonials</h2>

      <Swiper className='container testimonial_container'
       // install Swiper modules
       modules={[ Pagination]}
       spaceBetween={40}
       slidesPerView={1}
   
       pagination={{ clickable: true }}
      >
            {
              data.map(({avatar,name,review},index)=>{
                return(
                  <SwiperSlide  key={index} className='testimonial swiper'>
                  <div className='client_avatar'>
                   <img  src={avatar} alt='harshit'/>
                  </div>
                   <h5 className='client_name'>{name}</h5>
                   <small className='client_review'>
                   {review}
                   </small>
                   </SwiperSlide>
                )
              })
            }

            

            
      </Swiper>
    </section>
  )
}

export default Testimonials